export enum statusBulletEnum {
	RED = 0,
	GREEN = 1,
	GRAY = 2,
	YELLOW = 3,
	BLACK = 4,
	HALF_RED_GREEN = 5,
	HALF_GREEN_RED = 6
}